addEventListener('DOMContentLoaded', () => {
	const container = document.querySelector('#global-message')
	if (!container) {
		return
	}

	const key = 'gm-popup'
	const dismissed = sessionStorage.getItem(key)

	if (!dismissed) {
		container.classList.add('visible')
	}

	container.querySelectorAll('a.close').forEach(anchor => {
		anchor.addEventListener('click', event => {
			event.preventDefault()
			container.remove()
			sessionStorage.setItem(key, 'true')
		})
	})
})